import React, { useEffect, createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
import { PricingProvider } from './context/PricingContext';
function Root() {
  useEffect(() => {
    // Delay pixel injection until first user interaction to reduce main-thread blocking
    let injected = false;
    function injectPixel() {
      if (injected) return;
      injected = true;
      (window as any).pixelId = '699af96d3d725a7be6354526';
      const a = document.createElement('script');
      a.setAttribute('async', '');
      a.setAttribute('defer', '');
      a.setAttribute('src', 'https://cdn.utmify.com.br/scripts/pixel/pixel.js');
      document.head.appendChild(a);
      window.removeEventListener('scroll', injectPixel);
      window.removeEventListener('mousemove', injectPixel);
      window.removeEventListener('touchstart', injectPixel);
      window.removeEventListener('keydown', injectPixel);
    }
    // Inject after 3s idle OR on first interaction — whichever comes first
    const timer = setTimeout(injectPixel, 3000);
    window.addEventListener('scroll', injectPixel, {
      passive: true,
      once: true
    });
    window.addEventListener('mousemove', injectPixel, {
      once: true
    });
    window.addEventListener('touchstart', injectPixel, {
      passive: true,
      once: true
    });
    window.addEventListener('keydown', injectPixel, {
      once: true
    });
    return () => clearTimeout(timer);
  }, []);
  return <PricingProvider data-id="element-347">
      <App data-id="element-348" />
    </PricingProvider>;
}
render(<Root data-id="element-349" />, document.getElementById('root'));